exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n:root {\n  --high-risk-color: #800080;\n  --moderate-risk-color: #FF6347;\n  --risk-color: #FFA07A;\n  --engaged-color: #409eff;\n  /* --improving-color: yellow; */\n  --improving-color:#FBB829;\n  --full-active-color: #67c23a;\n  --new-signup-color: #ffc0cb;\n  --signup-nobooking-color: #999999;\n}\n", ""]);

// exports
